const navLinks = [
  { label: '홈', href: '#home' },
  { label: '서비스', href: '#services' },
  { label: '자격기준', href: '#eligibility' },
  { label: '진행절차', href: '#process' },
  { label: '상담신청', href: '#contact' },
  { label: '회사소개', href: '#about' },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1a2e1f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand Column */}
          <div className="sm:col-span-2">
            <img
              src="https://static.readdy.ai/image/cd8cec768b3109c0a4823a362c5d27f5/f18308a8382c34f4574bec8e73cc4409.png"
              alt="머니박스대부중개 로고"
              className="h-10 sm:h-12 w-auto object-contain mb-3 sm:mb-4 brightness-0 invert"
            />
            <p className="text-white/60 text-xs sm:text-sm leading-relaxed mb-4 max-w-xs">
              7년째 한자리에서 신용카드 대출 전문 서비스를 제공하는 주식회사 머니박스대부중개입니다. 24시간 365일 고객의 금융 고민을 해결해드립니다.
            </p>
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
              <a
                href="tel:01066065909"
                className="flex items-center gap-1.5 bg-[#03C75A] text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg hover:bg-[#00A843] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                010-6606-5909
              </a>
              <a
                href="tel:027045909"
                className="flex items-center gap-1.5 bg-white/10 text-white text-xs sm:text-sm font-semibold px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                02-704-5909
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h5 className="text-white font-bold text-xs sm:text-sm uppercase tracking-wider mb-3 sm:mb-4">메뉴</h5>
            <ul className="space-y-2 sm:space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                    className="text-white/60 text-xs sm:text-sm hover:text-[#03C75A] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h5 className="text-white font-bold text-xs sm:text-sm uppercase tracking-wider mb-3 sm:mb-4">회사 정보</h5>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-white/60">
              <li>
                <span className="block text-white/40 text-xs mb-0.5">사업자번호</span>
                381-86-01843
              </li>
              <li>
                <span className="block text-white/40 text-xs mb-0.5">주소</span>
                서울시 마포구 신촌로 162, 706호
              </li>
              <li>
                <span className="block text-white/40 text-xs mb-0.5">영업시간</span>
                <span className="text-[#03C75A] font-semibold">24시간 365일</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-8 sm:mt-10 pt-5 sm:pt-6 flex flex-col md:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-white/40 text-xs text-center md:text-left">
            © 2026 주식회사 머니박스대부중개. All rights reserved.
          </p>
          <p className="text-white/30 text-xs text-center md:text-right leading-relaxed">
            본 사이트는 대부중개업 관련 정보 제공을 목적으로 운영됩니다. 대출은 상환능력 내에서 이용하시기 바랍니다.
          </p>
        </div>
      </div>
    </footer>
  );
}
